// Shared band definitions + module->section resolution for the MIM/LIM
// self-assessment appendices. Bands and thresholds match the report's
// SECTIONS chart (BlockReportIntro): % of "Very Confident"/"Confident"
// responses, categorized <60 / 60–89 / ≥90.

export const BANDS = [
  { key: "opportunity", label: "Opportunity", range: "< 60%", color: "#e67e22" },
  { key: "developing", label: "Developing", range: "60–89%", color: "#2B8DCC" },
  { key: "strength", label: "Strength", range: "90% or higher", color: "#69AF45" },
];

export const bandKeyForScore = (pct) =>
  pct >= 90 ? "strength" : pct >= 60 ? "developing" : "opportunity";

const norm = (s) =>
  (s || "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

/**
 * Resolve a module's score band from the report's per-section scores.
 * sectionsData is the [{name, positive}] array surfaced by BlockReportIntro
 * (already excludes the trailing Summary row). Match by normalized section
 * name first, then fall back to positional index (appendix modules are
 * authored in the same order as the report sections).
 *
 * @param {Array<{name:string, positive:number}>} sectionsData
 * @param {{section?:string}} module
 * @param {number} index
 * @returns {{ score:number, bandKey:string }|null}
 */
export const moduleBand = (sectionsData, module, index) => {
  if (!Array.isArray(sectionsData) || sectionsData.length === 0) return null;

  let match = null;
  if (module?.section) {
    match = sectionsData.find((s) => norm(s.name) === norm(module.section));
  }
  if (!match) match = sectionsData[index];
  if (!match) return null;

  const pct = Number(match.positive);
  if (Number.isNaN(pct)) return null;

  const score = Math.round(pct * 10) / 10;
  return { score, bandKey: bandKeyForScore(pct) };
};
